import {
  GET_ATTACHMENT,
  GET_ATTACHMENT_START,
  GET_ATTACHMENT_ERROR,
  CLEAR_ATTACHMENT,
} from '../actions/types';

const initialState = {
  documentAttachment: {},
  loading: false,
  error: undefined,
};

const findAttachmentStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAttachment = (state, action) => {
  return {
    ...state,
    loading: false,
    documentAttachment: action.payload,
  };
};

const findAttachmentError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const removeAttachment = (state) => {
  return {
    ...state,
    documentAttachment: {},
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ATTACHMENT_START:
      return findAttachmentStart(state);
    case GET_ATTACHMENT:
      return findAttachment(state, action);
    case GET_ATTACHMENT_ERROR:
      return findAttachmentError(state, action);

    case CLEAR_ATTACHMENT:
      return removeAttachment(state);

    default:
      return state;
  }
}
